class Classroom {
    roomnumber: string;
    avaliable?: boolean = true;
    intervals: any = [];
    startIntervals: string[] = [];
    endIntervals: string[] = [];
    until?: string;
    dropped: boolean = false;
    
    constructor(roomnumber: string) {
        this.roomnumber = roomnumber;
        this.startIntervals = [];
        this.endIntervals = [];
        this.intervals = [];
    }

    getSchedule(time: Date): { startDate: string; endDate: string; title: string; }[] {
        //returns a schedule object that the calendar can read

        //gets the year, month, and day from the date object
        let y = time.getFullYear();
        let m = time.getMonth() + 1;
        let d = time.getDate();

        //padds the month and day in order for the schedule to be displayed correctly
        let padded_m = m.toString().padStart(2, '0');
        let padded_d = d.toString().padStart(2, '0');

        //creates a result object that the calendar can read
        let result: { startDate: string; endDate: string; title: string; }[] = [];

        //takes the classroom objects occupied intervals and adds it to the calendar result object
        this.intervals.forEach((interval: any) => {
            let obj = { startDate: y+'-'+padded_m+'-'+padded_d+'T'+interval[0], endDate: y+'-'+padded_m+'-'+padded_d+'T'+interval[1], title: 'occupied' }
            result.push(obj)
        })

        return result;
    }

    getIntervals() {
        //console.log('intervs')
        //console.log(this.roomnumber)
        //console.log(this.intervals)
        //console.log(typeof this.intervals)
        return this.intervals;
    }

    addInterval(interval: string[]) {
        this.intervals.push(interval);
    }

    addStartInterval(startInterval: string) {
        this.startIntervals.push(startInterval);
    }

    addEndInterval(endInterval: string) {
        this.endIntervals.push(endInterval);
    }

    sortIntervals() {
        this.startIntervals.sort();
        this.endIntervals.sort();
    }

    setUntil(hour: string) {
        if (this.avaliable) {
            for (let i = 0; i < this.startIntervals.length; i++) {
                if (this.startIntervals[i] > hour) {
                    this.until = this.startIntervals[i];
                    break;
                }
            }
        }
        else {
            for (let i = 0; i < this.endIntervals.length; i++) {
                if (this.endIntervals[i] > hour) {
                    this.until = this.endIntervals[i];
                    break;
                }
            }
        }
    }

    getUntil() {
        if (this.until == null || this.until == undefined) {
            return "until the end of the day";
        }
        else {
            //return "until " + this.until;
            if (this.avaliable) {
                return "until " + ((parseInt(this.until.split(":")[0]) % 12) || 12).toString() + ":" + this.until.split(":")[1];
            }
            else {
                return "until after " + ((parseInt(this.until.split(":")[0]) % 12) || 12).toString() + ":" + this.until.split(":")[1];
            }
        }
    }


}

export default Classroom;